import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.Tag>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'tags',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Tag[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Tag>) {
      adapter.upsertOne(state, action);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.tag,
);

export const selectTagOptions = createSelector(selector.selectAll, (tags) => {
  return tags.map((tag) => {
    return {
      key: tag.tag,
      text: tag.tag.toUpperCase(),
      value: tag.tag,
    };
  });
});

export { reducer };
export default actions;
